module.exports = __webpack_public_path__ + "img/1435.83198f54.gif";